import PromotionBanner from './PromotionBanner.component';
export default PromotionBanner;